import { Injectable } from '@angular/core';
import { AsyncSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { finalize, take } from 'rxjs/operators';
import { Uploadable } from '@akiba/models_beta_temp';
import { LocalHelpers } from '../misc/localHelpers';
import { HTTPRequestService } from './httpRequest.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'any'
})
export class UploadService {

  httpBase = environment.useAppEngineLocal ? environment.appEngineURLLocal : environment.appEngineURL;
  downloadURL: AsyncSubject<string> = new AsyncSubject();
  uploadPercentage: Subject<number> = new Subject();

  private percentageS: Subscription | undefined;
  private uploadS: Subscription | undefined;

  constructor(private storage: AngularFireStorage, private httpService: HTTPRequestService) {}



  async uploadToServer(upload: Uploadable): Promise<Uploadable> {

    const path = this.httpBase + '/helper/uploader';
    const formData = new FormData();
    formData.append('file', upload.file);
    const json = JSON.stringify(upload.toAny());
    formData.append('uploader', json);
    const uploadableObj = await this.httpService.postRequest(false, path, formData);
    const u = new Uploadable(uploadableObj);
    return u;

  }

  uploadToFirebase(upload: Uploadable): void {

    const fileRef = this.storage.ref(upload.bucket);
    const task = this.storage.upload(upload.bucket, upload.file);

    this.percentageS = task.percentageChanges().subscribe(percentage => {

      if (percentage) {

        this.uploadPercentage.next(percentage);
        if (percentage && percentage >= 100) {
          this.uploadPercentage.complete();
        }

      }

    });

    this.uploadS = task.snapshotChanges().pipe(finalize(async () => {

      const result = await firstValueFrom(fileRef.getDownloadURL());
      this.downloadURL.next(result);
      this.downloadURL.complete();
      this.reset();

    })).subscribe();

  }

  reset(): void {

    LocalHelpers.unsubscribe(this.percentageS);
    LocalHelpers.unsubscribe(this.uploadS);

    this.downloadURL = new AsyncSubject();
    this.uploadPercentage = new Subject();

  }

}
